<template>
  <div class="afdc-form-group">
    <label class="afdc-sr-only" v-bind:for="`afdc-find-fuel-${uniqueId}`">{{ $t('Fuel') }}</label>
    <select v-model="queryFuelFromArray" class="afdc-custom-select" v-bind:id="`afdc-find-fuel-${uniqueId}`" aria-controls="afdc-results-count" v-on:change="clearCorridor">
      <option v-for="option in fuelOptions" v-bind:key="option.key" v-bind:value="option.key">
      {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  data() {
    return {
      uniqueId: null,
    };
  },

  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.uniqueId = this._uid;
  },

  computed: {

    queryFuel: syncInputRouteQuery('fuel'),

    queryFuelFromArray: {
      get() {
        return this.queryFuel[0];
      },

      set(val) {
        if (typeof (val) !== 'undefined') {
          this.queryFuel = [val];
        } else {
          this.queryFuel = [];
        }
      },
    },

    fuelOptions() {
      const fuelTypes = this.$store.getters.loaderFuels;
      if (this.$route.name !== 'CorridorStations') {
        return fuelTypes;
      } return fuelTypes.filter((fuel) => fuel.key !== 'all' && fuel.key !== 'BD' && fuel.key !== 'E85' && fuel.key !== 'RD');
    },
  },
  methods: {
    clearCorridor() {
      if (this.$store.getters.isNavActiveTabCorridors) {
        this.$store.commit('setCorridorRouteStart', {});
        this.$store.commit('setCorridorRouteEnd', {});
        this.$store.commit('setClearCorridor');
      }
    },
  },
};
</script>

<style lang="scss">
</style>
